import React from 'react';
import {CircularProgress, Stack,} from "@mui/joy";
import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import Typography from "@mui/joy/Typography";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

// components
import BaseApi from "../../utils/BaseApi";
import CommonForm from "../Common/CommonForm";
import AttachmentCreate from "../Attachment/AttachmentCreate";
import CommonStepper from "../Common/CommonStepper";
import {flushSync} from "react-dom";
import {splitToList} from "../../utils/misc";


class RouteStateCreate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeStep: 0,
            lockedSteps: [],
            conditions: null,
            total: null,
            stageObj: null,
            stages: this.props.routeState.stage.next_stages,
            operatorObj: null,
            operators: [],
            attachments: null,
            selectedAttachments: [],
        };
        this.steps = [
            {
                order: 0,
                title: 'Следующий шаг',
            },
            {
                order: 1,
                title: 'Исполнитель',
            },
            {
                order: 2,
                title: 'Данные для шага',
            },
        ]
    }


    async componentDidMount() {
        let conditions = await this.retrieveConditions();
        let step = this.state.activeStep;
        let operator;
        let stage;
        let attachments;
        let lockedSteps = this.state.lockedSteps;
        attachments = await this.retrieveAttachments(
            this.props.routeState.stage.attachment_xtype
        );
        if (this.props.routeState.stage.promotion_logic === 'ITERATIVE'){
            if (!this.props.routeState.operator.parent) {
                step = 0;
            }
            else {
                step = 2;
                operator = this.props.routeState.operator.parent;
                stage = this.props.routeState.stage;
                lockedSteps = [0,1];
            }
        }
        if (this.state.stages.length === 0) {
            step = 2;
            stage = this.props.routeState.stage;
        }

        await this.setState(
            {
                activeStep: step,
                operatorObj: operator,
                stageObj: stage,
                lockedSteps: lockedSteps,
                attachments: attachments,
                selectedAttachments: this.props.previousRouteState?.attachments.map(
                    (a) => (a.id)
                ),
                ...conditions
            }
        )
    }

    async retrieveOperators(operator, logics) {
        let url = '';
        switch (logics){
            case 'NORMAL':
                url = `subscriber/`;
                break;
            case 'TREELIMITED':
                url = `subscriber/${this.props.systemOwner.id}/drilldown/`;
                break;
            default:
                return []
        }
        const params = {
            active: true,
            subscriber_type: operator.id,
            page_size: 10000,
        }
        const api = new BaseApi();
        let response = await api.get(
            url,
            params
        );
        return (
            response.data.results
        )
    }

    async retrieveStage(id) {
        const url = `route_stage/${id}`;
        const api = new BaseApi();
        let response = await api.get(
            url,
            {}
        );
        return (
            response.data
        )
    }

    async retrieveOperator(id) {
        const url = `subscriber/${id}`;
        const api = new BaseApi();
        let response = await api.get(
            url,
            {}
        );
        return (
            response.data
        )
    }

    async retrieveConditions() {
        const url = `route_state/${this.props.routeState.id}/conditions/`;
        const api = new BaseApi();
        let response = await api.get(url, {});
        return {
            conditions: response.data.conditions,
            total: response.data.total
        }
    }

    async retrieveAttachments(xtype){
        const url = `attachment/`;
        const api = new BaseApi();
        const params = {
            deleted_bool: false,
            related_app: this.props.entity,
            related_app_id: this.props.entity_id,
            xtype: xtype,
        }
        let response = await api.get(
            url,
            params
        );
        return response.data.results
    }

    async updateAttachments(id){
        let attachments = await this.retrieveAttachments();
        this.setState(
            {
                attachments: attachments,
                selectedAttachments: [...this.state.selectedAttachments, id],
            }
        );
    }

    async updateSelectedAttachments(form){
        flushSync(() => {})
        let attachments = (new FormData(form.target.form)).get('attachments')
        attachments = splitToList(attachments, ',')
        let intAttachments = []
        for (let attachment of attachments){
            intAttachments.push(parseInt(attachment))
        }
        this.setState(
            {
                selectedAttachments: intAttachments,
            }
        );
    }

    async processStep0(form, event) {
        let step;
        let operators;
        let operatorObj;
        let lockedSteps = this.state.lockedSteps;
        let stage = form.state.formData.get('stage');
        let stageObj = await this.retrieveStage(stage);

        if (stageObj.promotion_logic === 'SYSTEMOWNER'){
            step = 2;
            operatorObj = this.props.systemOwner;
            lockedSteps = [1, ]
        }
        else {
            operators = await this.retrieveOperators(
                stageObj.operator,
                stageObj.promotion_logic,
            );
            step = 1;
        }
        let attachments = await this.retrieveAttachments(
            stageObj.attachment_xtype
        );
        await this.setState(
            {
                activeStep: step,
                stageObj: stageObj,
                operators: operators,
                attachments: attachments,
                operatorObj: operatorObj,
                lockedSteps: lockedSteps,
            }
        );
    }

    async processStep1(form, event) {
        let operator = form.state.formData.get('operator');
        let operatorObj = await this.retrieveOperator(
            operator
        );
        await this.setState(
            {
                activeStep: 2,
                operatorObj: operatorObj,
            }
        );
    }

    async processStep2(form, event) {
        let formDataObj = Object.fromEntries(form.state.formData.entries());
        if (this.state.operatorObj){
            formDataObj['operator'] = this.state.operatorObj.id;
        }
        if (this.state.stageObj){
            formDataObj['stage'] = this.state.stageObj.id;
        }
        formDataObj['route'] = this.props.routeState.route;
        if (typeof(form.state.formData.attachments) !== 'undefined') {
            formDataObj.attachments = form.state.formData.attachments.split(',')
        }
        else {
            formDataObj.attachments = []
        }
        const url = `route_state/`;
        const api = new BaseApi();
        let response = await api.post(
            url,
            formDataObj,
        );
        if (response.status === 201) {
            await this.props.callBack();
        }
    }

    async setStep(order) {
        let formData = new FormData();
        let formFake = {'state': {'formData': formData}}
        if (order === 0){
            await this.componentDidMount()
        }
        else {
            await this['processStep'+(order-1)](formFake)
        }
        this.setState(
            {activeStep: order}
        )
    }

    render() {
        if (this.state.conditions === null){
            return (<CircularProgress/>)
        }
        if (this.state.attachments === null){
            return (<CircularProgress/>)
        }
        if (!this.state.total){
            return (
                <Card
                    color={'warning'}
                    variant="soft"
                    size={'sm'}
                >
                    <CardContent>
                        <Typography
                            level={'body-md'}
                        >
                            Требуется выполнить все условия стадии
                        </Typography>
                    </CardContent>
                </Card>
            )
        }
        if (this.state.activeStep === 0){
            return(
                <Card
                    color={'neutral'}
                    variant={'soft'}
                    sx={{
                        p: 0
                    }}
                >
                    <CommonStepper
                        lockedSteps={this.state.lockedSteps}
                        steps={this.steps}
                        activeStep={this.state.activeStep}
                        callBack={this.setStep.bind(this)}
                    />
                    <CommonForm
                        key={'step-0-form'}
                        fields={[
                            {
                                name: 'stage',
                                label: 'Стадия',
                                xs: 12,
                                sm: null,
                                md: null,
                                lg: null,
                                xl: null,
                                required: true,
                                default: this.state.stages?this.state.stages[0].id:null,
                                type: 'radio',
                                options: this.state.stages.map((each) => {return(
                                    {'value': each.id, 'label': each.title}
                                )})
                            },
                            {
                                type: 'submit',
                                label: 'Далее',
                                color: 'success',
                            }
                        ]}
                        processForm={this.processStep0.bind(this)}
                    />
                </Card>
            )
        }
        else if (this.state.activeStep === 1) {
            return(
                <Stack
                    spacing={2}
                >
                    <Card
                        color={'primary'}
                        variant={'soft'}
                    >
                        <CardContent>
                            <Typography>
                                <CheckCircleIcon
                                    color={'primary'}
                                    sx={{
                                        display: 'inline',
                                        mr: 1,
                                    }}
                                />
                                Стадия: {this.state.stageObj.title}
                            </Typography>
                        </CardContent>
                    </Card>
                    <Card
                        color={'neutral'}
                        variant={'soft'}
                        sx={{
                            p: 0
                        }}
                    >
                        <CommonStepper
                            lockedSteps={this.state.lockedSteps}
                            steps={this.steps}
                            activeStep={this.state.activeStep}
                            callBack={this.setStep.bind(this)}
                        />
                        <CommonForm
                            key={'step-1-form'}
                            fields={[
                                {
                                    name: 'operator',
                                    label: 'Исполнитель',
                                    xs: 12,
                                    sm: null,
                                    md: null,
                                    lg: null,
                                    xl: null,
                                    required: true,
                                    default: this.state.operators.length?this.state.operators[0].id:null,
                                    type: 'radio',
                                    options: this.state.operators.map((each) => {return(
                                        {
                                            'value': each.id,
                                            'label': `${each.user.first_name} ${each.user.last_name}`
                                        }
                                    )})
                                },
                                {
                                    type: 'submit',
                                    label: 'Далее',
                                    color: 'success',
                                }
                            ]}
                            processForm={this.processStep1.bind(this)}
                        />
                    </Card>
                </Stack>
            )
        }
        else if (this.state.activeStep === 2 && this.state.stageObj) {
            return(
                <Stack
                    spacing={2}
                >
                    <CommonStepper
                        lockedSteps={this.state.lockedSteps}
                        steps={this.steps}
                        activeStep={this.state.activeStep}
                        callBack={this.setStep.bind(this)}
                    />
                    {
                        this.state.operatorObj?
                            <Card
                                color={'primary'}
                                variant={'soft'}
                            >
                                <CardContent>
                                    <Typography>
                                        <CheckCircleIcon
                                            color={'primary'}
                                            sx={{
                                                display: 'inline',
                                                mr: 1,
                                            }}
                                        />
                                        Исполнитель: {this.state.operatorObj.user?.first_name} {this.state.operatorObj?.user.last_name}
                                    </Typography>
                                </CardContent>
                            </Card>:
                            null
                    }
                    {
                        this.state.stageObj?
                            <Card
                                color={'primary'}
                                variant={'soft'}
                            >
                                <CardContent>
                                    <Typography>
                                        <CheckCircleIcon
                                            color={'primary'}
                                            sx={{
                                                display: 'inline',
                                                mr: 1,
                                            }}
                                        />
                                        Стадия: {this.state.stageObj.title}
                                    </Typography>
                                </CardContent>
                            </Card>:
                            null
                    }
                    <Card
                        color={'neutral'}
                        variant={'soft'}
                        sx={{
                            p: 0
                        }}
                    >
                        <CommonStepper
                            lockedSteps={this.state.lockedSteps}
                            steps={this.steps}
                            activeStep={this.state.activeStep}
                            callBack={this.setStep.bind(this)}
                        />
                        <AttachmentCreate
                            appId={this.props.entity_id}
                            appName={this.props.entity}
                            xtype={this.state.stageObj.attachment_xtype}
                            callBack={this.updateAttachments.bind(this)}
                        />
                        <CommonForm
                            key={'step-2-form' + crypto.randomUUID()}
                            fields={[
                                {
                                    name: 'attachments',
                                    label: 'Вложения',
                                    xs: 12,
                                    sm: null,
                                    md: null,
                                    lg: null,
                                    xl: null,
                                    required: this.props.routeState.stage?this.props.routeState.stage.is_attach_needed:false,
                                    default: this.state.selectedAttachments,
                                    type: 'multiselect',
                                    options: this.state.attachments.map((each) => {return(
                                        {'value': each.id, 'label': each.uploadname}
                                    )})
                                },
                                {
                                    name: 'note',
                                    label: 'Комментарий',
                                    xs: 12,
                                    sm: null,
                                    md: null,
                                    lg: null,
                                    xl: null,
                                    required: this.props.routeState.stage?this.props.routeState.stage.is_note_needed:false,
                                    default: null,
                                    type: 'textarea',
                                    users: true,
                                },
                                {
                                    type: 'submit',
                                    label: 'Продвинуть',
                                    color: 'success',
                                }
                            ]}
                            object={null}
                            processForm={this.processStep2.bind(this)}
                            onChange={this.updateSelectedAttachments.bind(this)}
                        />
                    </Card>
                </Stack>
            )
        }
        return (
            <></>
        )
    }
}

export default RouteStateCreate